const initState = {
  ad_status: 2, // 广告状态
  ad_name: null, // 广告名称
  image: null, // 图片ID
  image_path: null, // 图片地址 不用组装的数据
  button_text: null, // 行动 按钮文案
  description: null, // 文案
  dest_url: null, // 落地页链接
  brand_name: null, // 品牌形象名称
  brand_img: null // 品牌形象图片id
}
const state = {
  ...initState,
  initState() {
    return initState
  }
}
const mutations = {
  // 获取广告状态
  getAdStatus(state, data) {
    state.ad_status = data
    console.log(state.ad_status, '我是ad_status')
  },
  // 获取广告名称
  getAdName(state, data) {
    state.ad_name = data
    console.log(state.ad_name, '我是ad_name')
  },
  // 获取image图片id
  getImageId(state, data) {
    state.image = data
    console.log(state.image, '我是image')
  },
  // 获取button_text行动按钮文案
  getButtonText(state, data) {
    state.button_text = data
    console.log(state.button_text, '我是button_text')
  },
  // 获取description文案
  getDescription(state, data) {
    state.description = data
    console.log(state.description, '我是description')
  },
  // 获取图片路径(不用传，仅展示)
  getImagePath(state, data) {
    state.image_path = data
  },
  // 获取落地页链接dest_url
  getDestUrl(state, data) {
    state.dest_url = data
    console.log(state.dest_url, '我是dest_url')
  },
  // 获取品牌形象名称
  getBrandName(state, data) {
    state.brand_name = data
    console.log(state.brand_name, '我是brand_name')
  },
  // 获取品牌形象图片id
  getBrandImg(state, data) {
    state.brand_img = data
    console.log(state.brand_img, '我是brand_img')
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
